import React from 'react';
import { YouTubeIcon, InstagramIcon, FacebookIcon, LinkedInIcon } from '../icons';
import generalLogo from '../assets/JakartaLogo.svg';
import ibLogo from '../assets/IB CONTINUUM.png';
import cambridgeLogo from '../assets/CAMBRIDGE.png';
import bseisiLogo from '../assets/BSEISI.png';
import nationalLogo from '../assets/TUT WURI HANDAYANI.png';
import cisLogo from '../assets/CIS MEMBER.png';

const SOCIALS = [
  { label: 'YouTube', Icon: YouTubeIcon, url: 'https://www.youtube.com/@gmisofficialchannel' },
  { label: 'Instagram', Icon: InstagramIcon, url: 'https://www.instagram.com/gmis.jakarta?igsi=Z2t6YWVsa2hoYmxt&utm_source=qr' },
  { label: 'Facebook', Icon: FacebookIcon, url: 'https://web.facebook.com/profile.php?id=61593232613210' },
  { label: 'LinkedIn', Icon: LinkedInIcon, url: 'https://linkedin.com/company/gmisschoolgroup' },
];

const getFooterLinkRoute = (label) => {
  const l = (label || '').toLowerCase();
  // Quick links
  if (l.includes('home') || l.includes('beranda')) return 'home';
  if (l.includes('history') || l.includes('sejarah') || l.includes('about') || l.includes('tentang')) return 'about';
  if (l === 'academics' || l === 'akademik') return 'curriculum-approach';
  if (l.includes('admission') || l.includes('penerimaan')) return 'admissions-process';
  if (l.includes('contact') || l.includes('kontak')) return 'contact';

  // Academics links
  if (l.includes('pyp') || l.includes('myp') || l.includes('dp')) return 'curriculum-approach';
  if (l.includes('career-related') || l.includes('cp')) return 'senior-school';
  if (l.includes('cambridge') || l.includes('igcse') || l.includes('checkpoint')) return 'middle-school';
  if (l.includes('student life') || l.includes('kehidupan siswa') || l.includes('life') || l.includes('siswa')) return 'extracurricular-activities';

  return 'home';
};

const Footer = ({ t, setPage }) => (
  /* full-width navy-deep bg */
  <div className="w-full bg-navy-deep text-white">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-[120px] pt-[72px] min-h-[620px] box-border flex flex-col justify-between">

      {/* ── Top row ── */}
      <div className="flex items-start justify-between gap-12">

        {/* Brand */}
        <div className="flex flex-col gap-3.5">
          <div className="flex items-center gap-4">
            <div
              onClick={() => {
                if (setPage) setPage('home');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="w-[78px] h-[78px] bg-white rounded-[8px] flex items-center justify-center p-1.5 shadow-sm cursor-pointer hover:opacity-95 transition-opacity shrink-0"
              title="Gandhi Memorial Intercontinental School"
            >
              <img src={generalLogo} alt="GMIS Logo" className="max-h-full max-w-full object-contain" />
            </div>
          </div>
          <div className="text-[11.5px] font-semibold tracking-[0.16em] text-gold">{t.est}</div>
        </div>

        {/* Contact */}
        <div className="flex flex-col gap-2.5 text-sm leading-[1.55] text-white/90">
          <div className="max-w-[320px]">Jl. HBR Motik D6 No. 1, Kemayoran, Central Jakarta, DKI Jakarta</div>
          <div>+62 21 6586 5667</div>
          <a
            href="mailto:admissions@gmis.sch.id"
            className="hover:text-gold transition-colors duration-200 w-fit cursor-pointer"
          >
            admissions@gmis.sch.id
          </a>
        </div>

        {/* Social icons */}
        <div className="flex gap-2.5 rounded-[10%]">
          {SOCIALS.map(({ label, Icon, url }) => (
            <a
              key={label}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="w-11 h-11 border border-white/35 flex items-center justify-center rounded-[8px] hover:border-gold transition-colors"
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>

      {/* ── Divider ── */}
      <div className="h-px bg-white/[0.18] my-12" />

      {/* ── Link columns ── */}
      <div className="grid grid-cols-4 gap-12">

        {/* Quick Links */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fQuick}</div>
          {t.quick.map((label) => (
            <a
              key={label}
              className="ulink flex items-center min-h-[36px] text-[15px] text-white/90 cursor-pointer hover:text-gold transition-colors duration-200"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                const route = getFooterLinkRoute(label);
                if (setPage) setPage(route);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              {label}
            </a>
          ))}
        </div>

        {/* Academics */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fAcad}</div>
          {t.acad.map((label) => (
            <a
              key={label}
              className="ulink flex items-center min-h-[36px] text-[15px] text-white/90 cursor-pointer hover:text-gold transition-colors duration-200"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                const route = getFooterLinkRoute(label);
                if (setPage) setPage(route);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              {label}
            </a>
          ))}
        </div>

        {/* Visiting Hours */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fHours}</div>
          <div className="flex flex-col border-t border-white/[0.18] text-[15px] text-white/90">
            <div className="flex justify-between py-3 border-b border-white/[0.18]">
              <span>{t.monFri}</span><span className="font-semibold">7.30 - 15.30</span>
            </div>
            <div className="flex justify-between py-3 border-b border-white/[0.18]">
              <span>{t.sat}</span><span className="font-semibold">08.00 - 13.00</span>
            </div>
          </div>
        </div>

        {/* Curriculum & Partners */}
        <div className="flex flex-col">
          <div className="text-[12px] font-bold tracking-[0.16em] uppercase text-gold pb-[14px]">{t.fAccred}</div>
          <div className="flex flex-col gap-2">
            {/* Top row: IB Continuum, Cambridge, BSEISI */}
            <div className="grid grid-cols-3 gap-2">
              <div
                className="h-[46px] bg-white rounded-[6px] flex items-center justify-center p-1.5 shadow-sm"
                title="IB Continuum"
              >
                <img src={ibLogo} alt="IB Continuum" className="max-h-full max-w-full object-contain" />
              </div>
              <div
                className="h-[46px] bg-white rounded-[6px] flex items-center justify-center p-1.5 shadow-sm"
                title="Cambridge Assessment International Education"
              >
                <img src={cambridgeLogo} alt="Cambridge" className="max-h-full max-w-full object-contain" />
              </div>
              <div
                className="h-[46px] bg-white rounded-[6px] flex items-center justify-center p-1.5 shadow-sm"
                title="BSEISI"
              >
                <img src={bseisiLogo} alt="BSEISI" className="max-h-full max-w-full object-contain" />
              </div>
            </div>

            {/* Bottom row: National Curriculum, CIS Member */}
            <div className="grid grid-cols-2 gap-2">
              <div
                className="h-[46px] bg-white rounded-[6px] flex items-center justify-center p-1.5 shadow-sm"
                title="National Curriculum"
              >
                <img src={nationalLogo} alt="National Curriculum" className="max-h-full max-w-full object-contain" />
              </div>
              <div
                className="h-[46px] bg-white rounded-[6px] flex items-center justify-center p-1.5 shadow-sm"
                title="CIS Member"
              >
                <img src={cisLogo} alt="CIS Member" className="max-h-full max-w-full object-contain" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="mt-12 h-[88px] flex items-center justify-between border-t border-white/[0.18] text-[13px] text-white/[0.78]">
        <div className="flex items-center gap-7">
          <span>{t.copy}</span>
          <a
            className="ulink cursor-pointer hover:text-gold transition-colors duration-200"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (setPage) setPage('coming-soon');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            {t.privacy}
          </a>
          <a
            className="ulink cursor-pointer hover:text-gold transition-colors duration-200"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (setPage) setPage('coming-soon');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            {t.terms}
          </a>
          <a
            className="ulink cursor-pointer hover:text-gold transition-colors duration-200"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (setPage) setPage('coming-soon');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            {t.sitemap}
          </a>
        </div>
        <button
          type="button"
          onClick={() => {
            if (setPage) setPage('contact');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="btn flex items-center h-[42px] px-6 rounded-[3px] bg-gold text-navy-deep text-[12.5px] font-bold tracking-widest uppercase cursor-pointer hover:brightness-110 transition-all border-0"
        >
          {t.enquiry}
        </button>
      </div>
    </div>
  </div>
);

export default Footer;

